export default "__VITE_ASSET__BGi$5JOw__"